<template>
  <svg
    :id="id"
    width="94"
    height="66"
    viewBox="0 0 94 66"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M77.0224 64.0141C86.0291 64.0141 93.3305 56.7127 93.3305 47.706C93.3305 38.6993 86.0291 31.3979 77.0224 31.3979C68.0157 31.3979 60.7144 38.6993 60.7144 47.706C60.7144 56.7127 68.0157 64.0141 77.0224 64.0141Z"
      fill="#88B5FE"
    />
    <path
      d="M77.0594 64.0039C86.0661 64.0039 93.3675 56.7025 93.3675 47.6958C93.3675 38.6891 86.0661 31.3877 77.0594 31.3877C68.0527 31.3877 60.7513 38.6891 60.7513 47.6958C60.7513 56.7025 68.0527 64.0039 77.0594 64.0039Z"
      :fill="fill0"
    />
    <path
      d="M93.3303 47.7059C93.3303 45.3519 92.8307 43.115 91.9332 41.0939C85.4859 41.0478 77.9078 50.5569 71.7378 52.0408C67.7924 52.9897 63.79 52.1537 61.1069 51.2752C62.7348 58.5649 69.2417 64.0139 77.0222 64.0139C86.0289 64.0139 93.3303 56.7125 93.3303 47.7059Z"
      :fill="fill1"
    />
    <path
      d="M93.3306 47.7063C93.3306 46.6555 93.2305 45.6282 93.0404 44.6328C86.4005 45.8808 78.9003 54.0532 72.7027 55.4199C69.0141 56.2333 65.2806 55.7349 62.4459 55.0228C65.1274 60.3552 70.647 64.0144 77.0226 64.0144C86.0292 64.0144 93.3306 56.713 93.3306 47.7063Z"
      :fill="fill2"
      fill-opacity="0.8"
    />
    <path
      d="M77.0223 64.0139C85.775 64.0139 92.9164 57.1183 93.3122 48.4634C86.6058 49.5336 78.9849 57.9116 72.7025 59.2968C70.3362 59.8186 67.9513 59.8 65.7969 59.532C68.7204 62.309 72.6716 64.0139 77.0223 64.0139Z"
      :fill="fill3"
      fill-opacity="0.8"
    />
    <path
      d="M92.6761 52.2896C86.1272 53.7584 78.7873 61.6594 72.7025 63.001C72.4119 63.0651 72.1209 63.1203 71.8301 63.1687C73.4609 63.7165 75.2067 64.0146 77.0224 64.0146C84.4377 64.0146 90.6957 59.0649 92.6761 52.2896Z"
      :fill="fill4"
      fill-opacity="0.8"
    />
    <path
      d="M77.0224 31.3979C68.0158 31.3979 60.7144 38.6994 60.7144 47.706C60.7144 47.8255 60.7164 47.9445 60.7188 48.0632C60.9088 39.6164 67.8152 32.8273 76.3078 32.8273C84.9198 32.8273 91.9012 39.8087 91.9012 48.4207C91.9012 56.9132 85.1121 63.8194 76.6653 64.0097C76.7842 64.0123 76.9031 64.0141 77.0224 64.0141C86.0291 64.0141 93.3305 56.7127 93.3305 47.706C93.3305 38.6994 86.0291 31.3979 77.0224 31.3979Z"
      :fill="fill5"
    />
    <path
      d="M38.5022 43.8937C49.204 39.1648 54.0459 26.6559 49.3171 15.9542C44.5882 5.25244 32.0793 0.410459 21.3775 5.13931C10.6758 9.86817 5.83386 22.3771 10.5627 33.0788C15.2916 43.7806 27.8005 48.6225 38.5022 43.8937Z"
      :fill="fill6"
    />
    <path
      d="M34.9176 39.5187C36.3542 38.8839 37.0041 37.2048 36.3693 35.7682C35.7345 34.3316 34.0554 33.6817 32.6188 34.3164C31.1823 34.9512 30.5323 36.6304 31.1671 38.067C31.8019 39.5035 33.481 40.1535 34.9176 39.5187Z"
      :fill="fill7"
    />
    <path
      d="M38.2121 17.9221C40.4554 16.9308 41.4703 14.3087 40.4791 12.0654C39.4878 9.82213 36.8657 8.80715 34.6224 9.79842C32.3791 10.7897 31.3641 13.4118 32.3554 15.6551C33.3466 17.8984 35.9688 18.9134 38.2121 17.9221Z"
      :fill="fill8"
    />
    <path
      d="M29.459 24.031C29.99 25.1903 29.4809 26.5601 28.3217 27.0912C27.1624 27.6223 25.7926 27.1131 25.2615 25.9539C24.7306 24.7949 25.2396 23.4248 26.3988 22.8937C27.5577 22.3628 28.9279 22.8718 29.459 24.031Z"
      :fill="fill9"
    />
    <path
      d="M18.0028 21.9138C18.5339 23.0731 18.0247 24.4429 16.8655 24.974C15.7065 25.5049 14.3364 24.9959 13.8053 23.8367C13.2742 22.6774 13.7834 21.3076 14.9426 20.7765C16.1019 20.2454 17.4717 20.7546 18.0028 21.9138Z"
      :fill="fill10"
    />
    <path
      d="M44.4463 28.1465C44.7565 28.8239 44.4592 29.6248 43.7815 29.9351C43.104 30.2452 42.3032 29.948 41.9929 29.2702C41.6827 28.5928 41.9799 27.7919 42.6577 27.4816C43.3351 27.1715 44.1358 27.4692 44.4463 28.1465Z"
      :fill="fill11"
    />
    <path
      d="M26.0829 12.0747C26.3931 12.7521 26.0959 13.553 25.4181 13.8633C24.7406 14.1735 23.9398 13.8762 23.6295 13.1985C23.319 12.5212 23.6165 11.7201 24.2943 11.4098C24.9717 11.0997 25.7725 11.3974 26.0829 12.0747Z"
      :fill="fill12"
    />
    <mask
      :id="mask0"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="1"
      y="9"
      width="57"
      height="30"
    >
      <path
        d="M45.8201 10.4893C46.1832 10.9003 46.5313 11.3275 46.8639 11.7704C46.9912 11.7402 47.1218 11.7069 47.2475 11.6778C53.6881 10.1877 55.9163 10.903 56.2177 11.5607C56.5191 12.2184 55.6055 14.3728 50.2705 18.2771C45.638 21.6676 39.0955 25.3631 31.8482 28.6832C24.6009 32.0034 17.5294 34.5442 11.9368 35.8382C5.49623 37.3283 3.26807 36.613 2.96664 35.9553C2.66522 35.2976 3.57887 33.1432 8.91382 29.2389C9.01796 29.1628 9.12825 29.0852 9.23422 29.0088C9.11634 28.4674 9.02 27.925 8.94582 27.3819C3.75616 31.0314 0.637333 34.4157 1.6243 36.5705C3.50943 40.6853 18.5653 36.3927 32.4634 30.0256C46.3616 23.6588 59.4451 15.0604 57.56 10.9455C56.5727 8.79093 51.973 8.94257 45.8201 10.4893Z"
        :fill="fill13"
      />
    </mask>
    <g :mask="urlMask0">
      <path
        d="M45.8201 10.4893C46.1832 10.9003 46.5313 11.3275 46.8639 11.7704C46.9912 11.7402 47.1218 11.7069 47.2475 11.6778C53.6881 10.1877 55.9163 10.903 56.2177 11.5607C56.5191 12.2184 55.6055 14.3728 50.2705 18.2771C45.6379 21.6676 39.0955 25.3631 31.8482 28.6832C24.6009 32.0034 17.5294 34.5442 11.9368 35.8382C5.49623 37.3283 3.26807 36.613 2.96664 35.9553C2.66522 35.2976 3.57887 33.1432 8.91382 29.2389C9.01796 29.1628 9.12825 29.0852 9.23422 29.0088C9.11634 28.4674 9.02 27.925 8.94582 27.3819C3.75616 31.0314 0.637333 34.4157 1.6243 36.5705C3.50943 40.6853 18.5653 36.3927 32.4634 30.0256C46.3616 23.6588 59.4451 15.0604 57.56 10.9455C56.5727 8.79093 51.973 8.94258 45.8201 10.4893Z"
        fill="#B8D2FF"
      />
    </g>
    <path
      d="M82.0115 6.63982L80.6133 0.693848L79.2145 6.63982L73.7754 8.03866L79.2145 9.43683L80.6133 15.6979L82.0115 9.43683L87.925 8.03866L82.0115 6.63982Z"
      :fill="fill14"
    />
    <path
      d="M33.6851 56.9255L32.2869 50.9795L30.8881 56.9255L25.449 58.3243L30.8881 59.7225L32.2869 65.9835L33.6851 59.7225L39.5986 58.3243L33.6851 56.9255Z"
      :fill="fill15"
    />
    <path
      d="M70.2406 17.5138L69.5103 14.4082L68.7797 17.5138L65.9388 18.2445L68.7797 18.9747L69.5103 22.2449L70.2406 18.9747L73.3293 18.2445L70.2406 17.5138Z"
      :fill="fill16"
    />
    <path
      d="M48.0364 54.0851L47.3061 50.9795L46.5755 54.0851L43.7346 54.8158L46.5755 55.546L47.3061 58.8162L48.0364 55.546L51.1251 54.8158L48.0364 54.0851Z"
      :fill="fill17"
    />
    <defs>
      <linearGradient
        :id="paintLinear0"
        x1="72.4407"
        y1="32.4962"
        x2="74.1184"
        y2="57.1462"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#21409A" />
        <stop
          offset="1"
          stop-color="#2484C6"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        :id="paintLinear1"
        x1="75.7095"
        y1="57.2791"
        x2="79.348"
        y2="40.6461"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stop-color="#FD6B51"
          stop-opacity="0.41"
        />
        <stop
          offset="1"
          stop-color="#2484C6"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        :id="paintLinear2"
        x1="78.5508"
        y1="57.0008"
        x2="77.8361"
        y2="50.4386"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stop-color="#FD6B51"
          stop-opacity="0.36"
        />
        <stop
          offset="1"
          stop-color="#2484C6"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        :id="paintLinear3"
        x1="78.4293"
        y1="59.6923"
        x2="81.0999"
        y2="47.484"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stop-color="#FD6B51"
          stop-opacity="0.72"
        />
        <stop
          offset="1"
          stop-color="#2484C6"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        :id="paintLinear4"
        x1="82.6696"
        y1="62.1545"
        x2="82.1498"
        y2="56.6319"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stop-color="#FD6B51"
          stop-opacity="0.78"
        />
        <stop
          offset="1"
          stop-color="#2484C6"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        :id="paintLinear5"
        x1="60.7144"
        y1="47.706"
        x2="93.3305"
        y2="47.706"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#88B5FE" />
        <stop
          offset="1"
          stop-color="#88B5FE"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        :id="paintLinear6"
        x1="10.6872"
        y1="33.3258"
        x2="49.2056"
        y2="15.6754"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#1592D1" />
        <stop
          offset="1"
          stop-color="#21409A"
        />
      </linearGradient>
      <linearGradient
        :id="paintLinear7"
        x1="32.6188"
        y1="34.3164"
        x2="34.9176"
        y2="39.5187"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#8BB8FF" />
        <stop
          offset="1"
          stop-color="#4C70DF"
        />
        <stop
          offset="1"
          stop-color="#4C70DF"
        />
      </linearGradient>
      <linearGradient
        :id="paintLinear8"
        x1="34.6224"
        y1="9.79842"
        x2="38.2121"
        y2="17.9221"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#8BB8FF" />
        <stop
          offset="1"
          stop-color="#4C70DF"
        />
        <stop
          offset="1"
          stop-color="#4C70DF"
        />
      </linearGradient>
      <linearGradient
        :id="paintLinear9"
        x1="26.4272"
        y1="22.8809"
        x2="28.2933"
        y2="27.104"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#8BB8FF" />
        <stop
          offset="1"
          stop-color="#4C70DF"
        />
        <stop
          offset="1"
          stop-color="#4C70DF"
        />
      </linearGradient>
      <linearGradient
        :id="paintLinear10"
        x1="14.971"
        y1="20.7637"
        x2="16.8371"
        y2="24.9868"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#8BB8FF" />
        <stop
          offset="1"
          stop-color="#4C70DF"
        />
        <stop
          offset="1"
          stop-color="#4C70DF"
        />
      </linearGradient>
      <linearGradient
        :id="paintLinear11"
        x1="42.6742"
        y1="27.4742"
        x2="43.7649"
        y2="29.9425"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#8BB8FF" />
        <stop
          offset="1"
          stop-color="#4C70DF"
        />
        <stop
          offset="1"
          stop-color="#4C70DF"
        />
      </linearGradient>
      <linearGradient
        :id="paintLinear12"
        x1="24.3108"
        y1="11.4024"
        x2="25.4016"
        y2="13.8708"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#8BB8FF" />
        <stop
          offset="1"
          stop-color="#4C70DF"
        />
        <stop
          offset="1"
          stop-color="#4C70DF"
        />
      </linearGradient>
      <linearGradient
        :id="paintLinear13"
        x1="25.5449"
        y1="16.3016"
        x2="32.3574"
        y2="28.8053"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#666666" />
        <stop
          offset="1"
          stop-color="#999999"
        />
      </linearGradient>
      <linearGradient
        :id="paintLinear14"
        x1="73.7757"
        y1="8.19572"
        x2="87.9252"
        y2="8.19572"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stop-color="#80B1FF"
          stop-opacity="0.5"
        />
        <stop
          offset="1"
          stop-color="#88B5FE"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        :id="paintLinear15"
        x1="25.4493"
        y1="58.4814"
        x2="39.5988"
        y2="58.4814"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stop-color="#80B1FF"
          stop-opacity="0.5"
        />
        <stop
          offset="1"
          stop-color="#88B5FE"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        :id="paintLinear16"
        x1="65.939"
        y1="18.3265"
        x2="73.3294"
        y2="18.3265"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stop-color="#80B1FF"
          stop-opacity="0.5"
        />
        <stop
          offset="1"
          stop-color="#88B5FE"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        :id="paintLinear17"
        x1="43.7348"
        y1="54.8978"
        x2="51.1252"
        y2="54.8978"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stop-color="#80B1FF"
          stop-opacity="0.5"
        />
        <stop
          offset="1"
          stop-color="#88B5FE"
          stop-opacity="0"
        />
      </linearGradient>
    </defs>
  </svg>
</template>
<script>
export default {
  props: ['id'],
  computed: {
    fill0() {
      return `url(#paint0_linear_${this.id})`;
    },
    fill1() {
      return `url(#paint1_linear_${this.id})`;
    },
    fill2() {
      return `url(#paint2_linear_${this.id})`;
    },
    fill3() {
      return `url(#paint3_linear_${this.id})`;
    },
    fill4() {
      return `url(#paint4_linear_${this.id})`;
    },
    fill5() {
      return `url(#paint5_linear_${this.id})`;
    },
    fill6() {
      return `url(#paint6_linear_${this.id})`;
    },
    fill7() {
      return `url(#paint7_linear_${this.id})`;
    },
    fill8() {
      return `url(#paint8_linear_${this.id})`;
    },
    fill9() {
      return `url(#paint9_linear_${this.id})`;
    },
    fill10() {
      return `url(#paint10_linear_${this.id})`;
    },
    fill11() {
      return `url(#paint11_linear_${this.id})`;
    },
    fill12() {
      return `url(#paint12_linear_${this.id})`;
    },
    fill13() {
      return `url(#paint13_linear_${this.id})`;
    },
    fill14() {
      return `url(#paint14_linear_${this.id})`;
    },
    fill15() {
      return `url(#paint15_linear_${this.id})`;
    },
    fill16() {
      return `url(#paint16_linear_${this.id})`;
    },
    fill17() {
      return `url(#paint17_linear_${this.id})`;
    },
    paintLinear0() {
      return `paint0_linear_${this.id}`;
    },
    paintLinear1() {
      return `paint1_linear_${this.id}`;
    },
    paintLinear2() {
      return `paint2_linear_${this.id}`;
    },
    paintLinear3() {
      return `paint3_linear_${this.id}`;
    },
    paintLinear4() {
      return `paint4_linear_${this.id}`;
    },
    paintLinear5() {
      return `paint5_linear_${this.id}`;
    },
    paintLinear6() {
      return `paint6_linear_${this.id}`;
    },
    paintLinear7() {
      return `paint7_linear_${this.id}`;
    },
    paintLinear8() {
      return `paint8_linear_${this.id}`;
    },
    paintLinear9() {
      return `paint9_linear_${this.id}`;
    },
    paintLinear10() {
      return `paint10_linear_${this.id}`;
    },
    paintLinear11() {
      return `paint11_linear_${this.id}`;
    },
    paintLinear12() {
      return `paint12_linear_${this.id}`;
    },
    paintLinear13() {
      return `paint13_linear_${this.id}`;
    },
    paintLinear14() {
      return `paint14_linear_${this.id}`;
    },
    paintLinear15() {
      return `paint15_linear_${this.id}`;
    },
    paintLinear16() {
      return `paint16_linear_${this.id}`;
    },
    paintLinear17() {
      return `paint17_linear_${this.id}`;
    },
    mask0() {
      return `mask0_${this.id}`;
    },
    urlMask0() {
      return `url(#mask0_${this.id})`;
    },
  },
};
</script>
